var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.value,
            direction: "rtl",
            size: "1100px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c("search-page", {
            directives: [
              {
                name: "hasPermi",
                rawName: "v-hasPermi",
                value: ["platform:task:statistics:detail"],
                expression: "['platform:task:statistics:detail']",
              },
            ],
            ref: "searchPage",
            attrs: {
              "column-count": 3,
              immediate: false,
              "form-data": _vm.formData,
              columns: _vm.columns,
              request: _vm.getList,
            },
            scopedSlots: _vm._u([
              {
                key: "table-application",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c("div", [_vm._v(_vm._s(row.applicationName))]),
                        _c(
                          "el-tag",
                          { staticClass: "table-tag", attrs: { type: "info" } },
                          [_vm._v("ID：" + _vm._s(row.applicationId))]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "table-userInfo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _c("div", [
                        _vm._v("用户名：" + _vm._s(row.userName || "-")),
                      ]),
                      _c("div", [_vm._v("ID：" + _vm._s(row.userId))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }